export default {
  directives: {
    clickOutside: { // 是否点在元素外
      bind (el, binding, vnode) {
        vnode.context.globalClick(e => {
          if (!el.contains(e.target)) binding.value()
        })
      }
    }
  },
  methods: {
    change_animation (type, animate, isTrigger = false) {
      if (type === 'module_animation') {
        this.$store.state.app.module_Data.data.animateType = type
        this.$store.state.app.module_Data.data.animateObj = {
          value: animate.id,
          animate: animate.formData
        }
        if (isTrigger) this.play()
      }
      if (type === 'comb_animation') {
        this.$store.state.app.module_Data.data.animateType = type
        this.$store.state.app.module_Data.data.animateCombObj = {
          value: animate.id,
          animate: animate.formData
        }
        if (isTrigger) this.play()
      }
      if (type === 'image_animation') {
        for (let i = 0; i < $(`#u${this.$store.state.app.module_Data.widgets_id} .animationBox`).length; i++) {
          this.templet.changeImageAnimation(animate, this.$store.state.app.module_Data.data.img_effects, $(`#u${this.$store.state.app.module_Data.widgets_id} .animationBox`)[i])
        }
      }
      if (type === 'banner_animation') {
        this.$store.state.app.module_Data.data.animateType = type
        this.$store.state.app.module_Data.data.listArr.animateObj = {
          value: animate.id,
          animate: animate.formData
        }
        if (isTrigger) this.play()
      }
    },
    play (animateType, animate,type = 'animation') {
      //debugger
      if (this.$store.state.app.module_Data.data.animateType === 'module_animation' && type == 'animation') {
        let direction = this.$store.state.app.module_Data.data.animateObj.animate.direction
        // if (this.$store.state.app.module_Data.data.animateObj.animate._key === 'bounceIn') {
        //   if (direction === 'left') {
        //     direction = 'right'
        //   } else if (direction === 'right') {
        //     direction = 'left'
        //   }
        // }
        const dom = document.querySelector('[data-animation-key="j-' + this.$store.state.app.module_Data.widgets_id + '"]')
        const loop = this.$store.state.app.module_Data.data.animateObj.animate.loop
        dom.style.animation = this.$store.state.app.module_Data.data.animateObj.animate.duration + 's ease ' + this.$store.state.app.module_Data.data.animateObj.animate.delay + 's ' + (loop === 10 ? 'infinite' : (loop || 0) + 1) + ' normal both running ' + this.$store.state.app.module_Data.data.animateObj.animate._key + this.directionMap(direction)
      }
      if (this.$store.state.app.module_Data.data.animateType === 'comb_animation' && type == 'animation') {
        const combDom = document.querySelectorAll('[data-animation-key="j-' + this.$store.state.app.module_Data.widgets_id + '"] [data-comb-dom]')
        combDom.forEach((comb, i) => {
          comb.style.animation = '0s ease 0s 1 normal none running none'
          comb.style.opacity = '0'
          setTimeout(() => {
            comb.style.animation = this.getCombAnimationStyle(this.$store.state.app.module_Data.data.animateCombObj, i,comb)
            comb.style.opacity = '1'
          })
          comb.addEventListener('animationend', function () {
            comb.style.animation = '0s ease 0s 1 normal none running none'
          })
        })
      }
      if (animateType === 'image_animation' && type == 'effect') {
        for (let i = 0; i < $(`#u${this.$store.state.app.module_Data.widgets_id} .animationBox`).length; i++) {
          this.templet.play_animation($(`#u${this.$store.state.app.module_Data.widgets_id} .animationBox`)[i], animateType, animate)
        }
      }
    },
    directionMap (direction) {
      const map = {
        default: '',
        left: 'Left',
        right: 'Right',
        top: 'Up',
        bottom: 'Down',
        leftRight: 'LeftRight',
        topBottom: 'UpDown'
      }
      return map[direction] || ''
    },
    getCombAnimationStyle (obj, i,dom) {
      //同时触发,一排一排出
      //if (obj.animate.trigger === 1) i = 0
      let s = 0;
      if(obj.animate.trigger === 1){
        const col_num = parseInt($(dom).attr('data-col_num'));
        const line = Math.ceil((i + 1)/ col_num) - 1;//第几排
        s = line * 0.4
      }
      else{
        s = i * 0.1
      }
      return '0.6s ease ' + s + 's 1 normal both running ' + obj.animate._key + this.directionMap(obj.animate.direction)
    },
    getLang(key){
      return this.$store.getters['language/get_lang'](key)
    },
    $systemTypeNameFormate(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js